import { render, staticRenderFns } from "./ConfiguracaoPlantaFabril.vue?vue&type=template&id=111d17fe&lang=pug"
import script from "./ConfiguracaoPlantaFabril.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoPlantaFabril.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoPlantaFabril.vue?vue&type=style&index=0&id=111d17fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports